import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { GET_GL_MASTER_DATA } from "./apiRoutes";

interface MutateProps {
  data: FieldValues;
  communityId: string;
}

const mutateValidateBulkUploadGlMaster = async ({ data, communityId }: MutateProps) => {
  return await axiosAuth.post(
    `${GET_GL_MASTER_DATA}/community/${communityId}/bulk/validate`,
    data,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
};

const useValidateBulkUploadGlMasterMutation = (
  queryParams?: UseMutationOptions<any, Error, MutateProps, unknown>
) =>
  useMutation({
    mutationFn: mutateValidateBulkUploadGlMaster,
    ...queryParams,
  });

export default useValidateBulkUploadGlMasterMutation;
